export default {
  LastNameFormField__ARIA: "Last name",
  LastNameFormField__LABEL: "Last name",
};
